import { useMutation } from '@tanstack/react-query';
import { apiClient, type ValidationResult } from '../api';
import { useHistory } from './useHistory';

export function useValidateEmail() {
  const { addToHistory } = useHistory();

  return useMutation({
    mutationFn: async (email: string): Promise<ValidationResult> => {
      const result = await apiClient.validateEmail(email);
      return result;
    },
    onSuccess: (result) => {
      addToHistory({
        email: result.email,
        result,
      });
    },
  });
}
